"use client";
import Link from "next/link";
import { useI18n } from "providers/I18nProvider";
import { localizePath } from "utils/locale";

/**
 * Link nội bộ có nhớ ngôn ngữ: khi khách đang ở bản tiếng Anh, mọi đường dẫn
 * bắt đầu bằng "/" tự được thêm tiền tố "/en" để họ không bị rơi ngược về
 * tiếng Việt giữa chừng. Link ngoài (http…) giữ nguyên.
 */
type NextLinkProps = React.ComponentProps<typeof Link>;

export default function LinkComponent({
  href,
  children,
  className,
  ...props
}: Omit<NextLinkProps, "href"> & { href: string }) {
  const { locale } = useI18n();
  return (
    <Link href={localizePath(href, locale)} className={className} {...props}>
      {children}
    </Link>
  );
}
